import axiosPost from "./axiosPost";

export const RNHServicioIns = async (credentials, data) => {
    const body = {
        service: "RNHServicioIns",
        params: {
            rnhServicioCod: data?.cod || null,
            rnhServicioNombre: data?.name || null,
            rnhServicioDescripcion: data?.desc || null
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
